export const Apiurl = "https://linioservices.azurewebsites.net/";
//export const Apiurl = "http://127.0.0.1:8000/";